import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { usePropertyStore } from "@features/property/propertyStore"

import PropertyFeatureCard, { PropertyFeatureCardData } from "@features/property/PropertyFeatureCard"
import AddPropertyModal from "@features/property/AddPropertyModal"
import FilterAndSortListProperties from "@features/property/FilterAndSortListProperties"
import PortalShell from "../Common/PortalShell"

const propertySortOptions: Array<{ value: keyof PropertyFeatureCardData; label: string }> = [
  { value: "address", label: "Propriété (adresse)" },
  { value: "status", label: "Statut" },
  { value: "city", label: "Ville" },
]

const AddButton = styled.button`
  min-height: 46px;
  padding: 0 1rem;
  background-color: #1d6da6;
  color: #ffffff;
  border: 1px solid #1d6da6;
  border-radius: 2px;
  font: inherit;
  font-weight: 750;
  cursor: pointer;

  @media (max-width: 600px) {
    padding: 0.5rem;
  }
`

const AdminSurface = styled.section`
  padding: clamp(1rem, 3vw, 2rem);
  border: 1px solid #c4d0da;
  border-radius: 2px;
  background: #ffffff;
  box-shadow: 0 18px 50px rgba(8, 36, 60, 0.05);
`

const PropertyManager: React.FC = () => {
  const { properties, fetchAll, updateProperty, addProperty, removeProperty } = usePropertyStore()
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    fetchAll()
  }, [fetchAll])

  const handleAddProperty = (newProperty: { address: string; postalCode: string; city: string; description: string; status: string }) => {
    addProperty(newProperty).catch(console.error)
  }

  const handleEdit = (id: string, partialData: Partial<PropertyFeatureCardData>) => {
    updateProperty(id, partialData).catch(console.error)
  }

  const handleRemove = (id: string) => {
    removeProperty(id).catch(console.error)
  }

  const propertyCards: PropertyFeatureCardData[] = properties.map((property) => ({
    ...property,
    description: property.description || "",
  }))

  return (
    <PortalShell title="Immeubles" eyebrow="Administration">
      <AdminSurface>
        <FilterAndSortListProperties<PropertyFeatureCardData>
          items={propertyCards}
          renderItem={(item) => <PropertyFeatureCard data={item} onEdit={handleEdit} onRemove={handleRemove} />}
          searchFields={["address", "city", "postalCode"]}
          sortOptions={propertySortOptions}
          defaultSort="address"
          addButton={<AddButton onClick={() => setShowModal(true)}>Ajouter une propriété</AddButton>}
        />
        {showModal && <AddPropertyModal onClose={() => setShowModal(false)} onAdd={handleAddProperty} />}
      </AdminSurface>
    </PortalShell>
  )
}

export default PropertyManager
